"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Line(props) {
  return /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], _extends({
    height: 2,
    width: '100%',
    background: _styles.black
  }, props));
}

var _default = Line;
exports["default"] = _default;